import React        from 'react';
import PropTypes    from 'prop-types';
import AgeLabel     from '../Video/Item/AgeLabel';
import ReloadHelper from '../../utils/ReloadHelper';
import Translations from '../../utils/Translations';

class VideoSuggestion extends React.Component {

	static linkHandler(e) {
		ReloadHelper.reload(e.target.href, e);
	}

	render() {

		if(!this.props.link) {
			return null;
		}

		return (
			<div className='suggest-video__item'>
				<div className="suggest-video__item--premium-budge">{this.props.fsk === 18 ? Translations.get('Viewfrom18version') : Translations.get('Seenextepisode')}</div>
				<a onClick={this.linkHandler} href={this.props.link} className="suggest-video__item--url">
					<img src={this.props.preview} alt={this.props.title} />
					<i className="icon -icon-play-rounded-line" />
					<AgeLabel age={this.props.fsk} />
				</a>
				<a onClick={this.linkHandler} href={this.props.link} className="suggest-video__item--title">
					{this.props.isPremium && <span>{Translations.get('TVMediathekTagPrime')} - </span>}
					{this.props.title}
				</a>
			</div>
		);
	}
}

VideoSuggestion.propTypes = {
	title:       PropTypes.string,
	link:        PropTypes.string,
	fsk:         PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	isPremium:   PropTypes.bool,
	preview:     PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};

VideoSuggestion.defaultProps = {
	preview: false,
	fsk:     12,
};

export default VideoSuggestion;



